import React from 'react';
import './Alts.css';
import alts_img from "../assets/alts.jpg";
import GlassyButton from "./GlassyButton";

const Alts = () => {

    const handleClick = () => {
        const username = "obmenvpermi";
        const url = `https://t.me/${username}`;

        window.location.href = url;

        if (window.Telegram?.WebApp?.openTelegramLink) {
            window.Telegram.WebApp.openTelegramLink(url);
        }
    };

    return (
        <div className={'alts-wrapper card'}>

            <div className={'hero-bg-img-container'}>
                <img className={'hero-bg-img'} src={alts_img} alt="exchange"/>
            </div>

            <div className={'alts-container'}>

                <div className={'hero-text'}>
                    <h2 className={''} style={{marginBottom: '-4px'}}>Обмен популярных криптовалют</h2>
                    <p className={'p opacity75'}>
                        Меняем Bitcoin, Ethereum и другие популярные монеты. Узнать
                        точный курс можно в личных сообщениях с оператором.
                    </p>
                </div>

                {/*<button onClick={() => handleClick()} className={'btn white full'}>
                    Узнать точный курс
                </button>*/}

                <GlassyButton onClick={() => handleClick()} className={'full'}>
                    Узнать точный курс
                </GlassyButton>

            </div>

        </div>
    );
};

export default Alts;